const getIsSSR = () =>
    !(
        typeof window !== 'undefined' &&
        window.document &&
        window.document.createElement
    );

module.exports = getIsSSR;
